import React from 'react'

// components

import CardUser from 'components/Cards/CardUser.js'

export default function CreateUser() {
    return (
        <>
            <div className="flex flex-wrap">
                <div className="w-full lg:w-12 px-4">
                    <CardUser />
                </div>
            </div>
        </>
    )
}
